module.exports = __webpack_public_path__ + "static/media/decoration.3036ebf2.svg";